(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["goris-footer"] && !Shopify.designMode) return;
  try {
    
  // Native Shopify consent UI owns both the dialog and the saved preferences.
  // This control only opens it; it never changes consent on the visitor's behalf.
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-goris-cookie-button]');
    if (!button || button.getAttribute('aria-busy') === 'true') return;
    const status = document.getElementById(button.getAttribute('aria-describedby'));
    if (!status) return;
    if (window.Shopify?.designMode) {
      status.textContent = button.dataset.editor;
      return;
    }
    button.setAttribute('aria-busy', 'true');
    status.textContent = button.dataset.loading;
    let timeout;
    try {
      await Promise.race([
        (async () => {
          // The native banner can finish loading after the footer becomes interactive.
          for (let attempt = 0; attempt < 20; attempt += 1) {
            if (typeof window.privacyBanner?.showPreferences === 'function') {
              await window.privacyBanner.showPreferences();
              return;
            }
            await new Promise((resolve) => setTimeout(resolve, 250));
          }
          throw new Error('Privacy preferences unavailable');
        })(),
        new Promise((_, reject) => { timeout = setTimeout(() => reject(new Error('Privacy preferences timed out')), 6000); })
      ]);
      status.textContent = '';
    } catch {
      status.textContent = button.dataset.error;
    } finally {
      clearTimeout(timeout);
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["goris-product-description"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-detail-sections')) {
    customElements.define('product-detail-sections', class extends HTMLElement {
      connectedCallback() {
        this.organizeDescription();
        this.links = Array.from(this.querySelectorAll('[data-detail-link]'));
        this.sections = Array.from(this.querySelectorAll('[data-detail-section]'));
        this.toolbar = this.querySelector('.goris-product-toolbar');
        this.toolbarSlot = this.querySelector('.goris-product-toolbar-slot');
        this.purchaseTarget = this.querySelector('[data-detail-purchase]');
        this.header = document.querySelector('#header-component');
        if (!this.links.length || !this.toolbar || !this.toolbarSlot) return;
        this.abort?.abort();
        this.abort = new AbortController();
        const { signal } = this.abort;
        this.links.forEach((link, index) => {
          link.addEventListener('click', (event) => {
            if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
            event.preventDefault();
            const section = this.sections[index];
            const url = new URL(window.location.href);
            url.hash = section.id;
            if (url.href !== window.location.href) window.history.pushState(window.history.state, '', url);
            this.goToSection(section, true);
          }, { signal });
        });
        const schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            this.updatePosition();
          });
        };
        document.addEventListener('scroll', schedule, { capture: true, passive: true, signal });
        window.addEventListener('resize', schedule, { passive: true, signal });
        window.addEventListener('hashchange', () => this.openFragment(), { signal });
        this.observer = new ResizeObserver(schedule);
        this.observer.observe(this.toolbar);
        if (this.header) this.observer.observe(this.header);
        this.updatePosition();
        customElements.whenDefined('sticky-add-to-cart').then(() => {
          if (signal.aborted) return;
          const purchase = Array.from(document.querySelectorAll('sticky-add-to-cart')).find((element) => element.dataset.productId === this.dataset.productId && !element.hasAttribute('data-embedded'));
          const source = purchase?.closest('.shopify-section');
          const target = this.querySelector('[data-detail-purchase]');
          if (purchase && source && target) {
            this.purchase = purchase;
            this.purchaseSource = source;
            this.observer.observe(source);
            this.purchaseOrigin = document.createElement('span');
            this.purchaseOrigin.hidden = true;
            purchase.before(this.purchaseOrigin);
            purchase.dataset.sourceSectionId = source.id;
            purchase.dataset.embedded = 'true';
            target.append(purchase);
          }
          this.updatePosition();
          this.openFragment();
        });
        this.openFragment();
      }
      organizeDescription() {
        if (!this.hasAttribute('data-description-unsplit')) return;
        const overview = this.querySelector('.goris-product-description__overview > .rte');
        const specifications = this.querySelector('.goris-product-description__specifications');
        const contents = this.querySelector('.goris-product-description__contents');
        if (!overview || !specifications || !contents) return;
        this.removeAttribute('data-description-unsplit');
        const normalize = (text) => text.normalize('NFKC').replace(/\s+/g, ' ').trim().toLocaleLowerCase('fr');
        const inlineTags = new Set(['STRONG', 'B', 'EM', 'I', 'SPAN', 'BR', 'SMALL', 'SUP', 'SUB']);
        const inlineOnly = (element) => !element.querySelector('[hidden], [aria-hidden="true"]') && Array.from(element.querySelectorAll('*')).every((child) => inlineTags.has(child.tagName));
        const flatList = (list) => list.tagName === 'UL' && list.children.length > 0 && Array.from(list.childNodes).every((node) => node.nodeType === 8 || (node.nodeType === 3 && !node.textContent.trim()) || (node.nodeType === 1 && node.tagName === 'LI' && inlineOnly(node)));
        const labels = new Set(['univers', 'extension', 'format', 'langue', 'contenu']);
        const lists = Array.from(overview.children).filter(flatList);
        const characteristicLists = lists.filter((list) => {
          const keys = Array.from(list.children, (item) => {
            const match = normalize(item.textContent).match(/^([^:]+):\s*(\S.*)$/);
            return match ? match[1].trim() : '';
          });
          return keys.length >= 2 && keys.includes('format') && keys.every((key) => labels.has(key)) && new Set(keys).size === keys.length;
        });
        const packHeadings = Array.from(overview.children).filter((heading) => {
          if (heading.tagName !== 'H3' || heading.id || heading.querySelector('[id]') || !inlineOnly(heading)) return false;
          if (!['contenu du coffret', 'le contenu du coffret'].includes(normalize(heading.textContent).replace(/\s*:$/, ''))) return false;
          let next = heading.nextSibling;
          while (next && (next.nodeType === 8 || (next.nodeType === 3 && !next.textContent.trim()))) next = next.nextSibling;
          return lists.includes(next) && !characteristicLists.includes(next);
        });
        const aliases = { 'langue des cartes': 'langue', 'contenu du produit': 'contenu' };
        const fallbackKeys = Array.from(specifications.querySelectorAll('dt')).filter((term) => term.nextElementSibling?.tagName === 'DD' && term.nextElementSibling.textContent.trim()).map((term) => {
          const key = normalize(term.textContent).replace(/\s*:$/, '');
          return aliases[key] || key;
        });
        const characteristic = characteristicLists.length === 1 && fallbackKeys.every((key) => Array.from(characteristicLists[0].children).some((item) => normalize(item.textContent).split(':')[0].trim() === key)) ? characteristicLists[0] : null;
        const heading = packHeadings.length === 1 && !contents.querySelector('.goris-product-description__pack') ? packHeadings[0] : null;
        const moved = [characteristic, heading, heading?.nextElementSibling];
        if (!Array.from(overview.childNodes).some((node) => !moved.includes(node) && node.textContent.trim())) return;
        if (characteristic) specifications.replaceChildren(characteristic);
        if (heading) {
          const pack = document.createElement('div');
          pack.className = 'goris-product-description__pack goris-product-description__text rte';
          pack.append(heading.nextElementSibling);
          contents.prepend(pack);
          contents.classList.add('goris-product-description__contents--with-pack');
          heading.remove();
        }
      }
      updatePosition() {
        const headerRect = this.header?.getBoundingClientRect();
        const offset = headerRect ? Math.max(0, Math.min(headerRect.bottom, headerRect.height)) : 0;
        this.updatePurchaseVisibility(offset);
        const slotRect = this.toolbarSlot.getBoundingClientRect();
        this.style.setProperty('--goris-details-header-offset', `${offset}px`);
        this.style.setProperty('--goris-details-toolbar-left', `${slotRect.left}px`);
        this.style.setProperty('--goris-details-toolbar-width', `${slotRect.width}px`);
        this.toolbar.toggleAttribute('data-fixed', slotRect.top <= offset);
        const height = this.toolbar.getBoundingClientRect().height;
        this.toolbarSlot.style.height = `${height}px`;
        this.style.setProperty('--goris-details-toolbar-height', `${height}px`);
        const active = this.sections.reduce((current, section, index) => section.getBoundingClientRect().top <= offset + height + 48 ? index : current, 0);
        this.links.forEach((link, index) => {
          if (index === active) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
      }
      updatePurchaseVisibility(offset) {
        if (!this.purchaseTarget) return;
        const mainButton = this.purchaseSource?.querySelector(`product-form-component[data-product-id="${this.dataset.productId}"] [ref="addToCartButton"]`);
        const rect = mainButton?.getBoundingClientRect();
        const visible = Boolean(this.purchase && rect?.width > 0 && rect?.height > 0 && rect.bottom <= offset);
        if (!visible && this.purchaseTarget.contains(document.activeElement)) {
          const focusTarget = mainButton && !mainButton.disabled ? mainButton : this.links[0];
          focusTarget?.focus({ preventScroll: true });
        }
        this.purchaseTarget.hidden = !visible;
        this.purchaseTarget.inert = !visible;
        this.purchaseTarget.setAttribute('aria-hidden', String(!visible));
      }
      goToSection(section, smooth = false) {
        this.updatePosition();
        section.querySelector('h2')?.focus({ preventScroll: true });
        if (this.purchase && this.purchaseTarget?.hidden && window.matchMedia('(max-width: 1199px)').matches) {
          section.scrollIntoView({ block: 'start', behavior: 'instant' });
          this.updatePosition();
          section.scrollIntoView({ block: 'start', behavior: 'instant' });
          return;
        }
        section.scrollIntoView({ block: 'start', behavior: smooth && !window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'smooth' : 'instant' });
      }
      openFragment() {
        let id;
        try { id = decodeURIComponent(window.location.hash.slice(1)); } catch { return; }
        const section = id === this.id ? this.sections[0] : this.sections.find((element) => element.id === id || element.contains(document.getElementById(id)));
        if (section) this.goToSection(section);
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        if (this.purchase && this.purchaseOrigin?.isConnected) {
          delete this.purchase.dataset.embedded;
          this.purchaseOrigin.replaceWith(this.purchase);
          delete this.purchase.dataset.sourceSectionId;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
